<template>
  <span>
    <h1 class="font-semibold text-xl">Sales By History</h1>
    <SalesHistory />
  </span>
</template>

<script>
import SalesHistory from '../component/SalesHistory.vue';

export default {
  name: 'SalesByHistory',
  components: {
    SalesHistory,
  },
};
</script>

<style scoped>

</style>
